export const ComponentEvents = {
    TRANSITION_3D_STARTED: 'TRANSITION_3D_STARTED',
    TRANSITION_3D_ENDED: 'TRANSITION_3D_ENDED',
    TUNNEL_3D_AT_LOCATION: 'TUNNEL_3D_AT_LOCATION',
    TUNNEL_3D_READY: 'TUNNEL_3D_READY',
    TRANSITION_STARTED: 'TRANSITION_STARTED',
    TRANSITION_ENDED: 'TRANSITION_ENDED'
};
export default ComponentEvents;
